import React from 'react';
import './SellerInfo.css';

const SellerInfo = ({ seller }) => {
  // Mock data nếu không có seller
  const mockSeller = seller || {
    name: "Trần Nguyễn Đức Anh",
    avatar: "https://via.placeholder.com/60x60/4ade80/ffffff?text=AN",
    rating: 4.8,
    totalProducts: 24,
    memberSince: "2023-01-15",
    location: "Quận 1, TP.HCM",
    phone: "0901234567",
    email: "seller@example.com",
    verified: true,
    responseRate: 95,
    averageResponseTime: "2 giờ"
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("vi-VN");
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<span key={i} className="star filled">⭐</span>);
    }

    if (hasHalfStar) {
      stars.push(<span key="half" className="star half">⭐</span>);
    }

    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<span key={`empty-${i}`} className="star empty">⭐</span>);
    }

    return stars;
  };

  return (
    <div className="seller-info-container">
      {/* Seller Header */}
      <div className="seller-header">
        <div className="seller-avatar-section">
          <div className="seller-avatar">
            <img src={mockSeller.avatar} alt={mockSeller.name} />
            {mockSeller.verified && (
              <div className="verified-badge">
                ✓
              </div>
            )}
          </div>
          <div className="seller-basic-info">
            <h3 className="seller-name">{mockSeller.name}</h3>
            <div className="seller-rating">
              <div className="stars">
                {renderStars(mockSeller.rating)}
              </div>
              <span className="rating-text">{mockSeller.rating}/5</span>
            </div>
          </div>
        </div>
      </div>

      {/* Seller Stats */}
      <div className="seller-stats">
        <div className="stat-item">
          <span className="stat-icon">📦</span>
          <div className="stat-content">
            <span className="stat-value">{mockSeller.totalProducts}</span>
            <span className="stat-label">Sản phẩm</span>
          </div>
        </div>
        <div className="stat-item">
          <span className="stat-icon">📅</span>
          <div className="stat-content">
            <span className="stat-value">{formatDate(mockSeller.memberSince)}</span>
            <span className="stat-label">Tham gia</span>
          </div>
        </div>
        <div className="stat-item">
          <span className="stat-icon">📍</span>
          <div className="stat-content">
            <span className="stat-value">{mockSeller.location}</span>
            <span className="stat-label">Địa chỉ</span>
          </div>
        </div>
      </div>

      {/* Seller Performance */}
      <div className="seller-performance">
        <h4 className="performance-title">Hiệu suất bán hàng</h4>
        <div className="performance-items">
          <div className="performance-item">
            <span className="performance-label">Tỷ lệ phản hồi:</span>
            <div className="performance-bar">
              <div 
                className="performance-fill" 
                style={{ width: `${mockSeller.responseRate}%` }}
              ></div>
            </div>
            <span className="performance-value">{mockSeller.responseRate}%</span>
          </div>
          <div className="performance-item">
            <span className="performance-label">Thời gian phản hồi:</span>
            <span className="performance-value">{mockSeller.averageResponseTime}</span>
          </div>
        </div>
      </div>

      {/* Contact Info */}
      <div className="seller-contact">
        <h4 className="contact-title">Thông tin liên hệ</h4>
        <div className="contact-items">
          <div className="contact-item">
            <span className="contact-icon">📞</span>
            <span className="contact-text">{mockSeller.phone}</span>
          </div>
          <div className="contact-item">
            <span className="contact-icon">✉️</span>
            <span className="contact-text">{mockSeller.email}</span>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="seller-actions">
        <button className="btn-view-profile">
          <span>👤</span>
          Xem trang cá nhân
        </button>
        <button className="btn-follow">
          <span>➕</span>
          Theo dõi
        </button>
      </div>

      {/* Seller Badges */}
      <div className="seller-badges">
        <div className="badge-item">
          <span className="badge-icon">🏆</span>
          <span className="badge-text">Người bán uy tín</span>
        </div>
        <div className="badge-item">
          <span className="badge-icon">⚡</span>
          <span className="badge-text">Phản hồi nhanh</span>
        </div>
        <div className="badge-item">
          <span className="badge-icon">🛡️</span>
          <span className="badge-text">Đã xác thực</span>
        </div>
      </div>
    </div>
  );
};

export default SellerInfo;